export default __webpack_public_path__ + "static/media/doomingpresence.850bb74d.png";